import JsonTextStyles from '../assets/textstyles.json' 

export const TextStyles = JsonTextStyles
